module.exports = __webpack_public_path__ + "static/media/tab_active.214209e4.png";